import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { usePropsSelect } from '../../../../../hooks/useProps/usePropsSelect';
import { initialAllOptionPromises } from '../../../../../helper/utils';
import { useGetOptionsSelect } from '../../../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import { useManageGetRequest } from '../../../../../hooks/useManageGetRequest/useManageGetRequest';
import { usePropsInputs } from '../../../../../hooks/useProps/usePropsInput';
import { useSubmitForm } from '../../../../../hooks/useSubmitForm/useSubmitForm';
import useDidMountEffect from '../../../../../hooks/useDidMountEffect/useDidMountEffect';
import InputText from '../../../../../components/modalComponents/InputText';
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import FooterModal from '../../../../../components/modalComponents/FooterModal';
import CardAccordion from '../../../../../components/pageComponents/CardAccordion';
import SpinnerLoading from '../../../../../components/pageComponents/SpinnerLoading';
import { KEYS_DATOS_IDENTIFICACION_NI, KEYS_CARD_NUEVOS_INGRESOS as OPTIONS, TIPOS_DOCUMENTO_IDENTIDAD } from '../../../../../constants/hardCodedConstants';
import { getEstadosCivilesAPI, getGenerosAPI, getTiposDocumentoAPI, getDatosIdentificacionGestionAPI, saveDatosIdentificacionAPI } from '../../../../../consumers/backendApisUrls';

const PruebaTecnica = ({ idNuevosIngresosEmpleado, idParent: ID_PARENT, inputDisabled, isColaborador, manageSearchListaDocumentos, sendCurrentStep, setSendCurrentStep, componentStep }) => {

  const SECTION_NAME = "EditarDatosIdentificacionFichaNuevosIngresos";
  const KEYS_INIT = {TipoDocumento: "IdTipoDocumento", Genero: "IdGenero", EstadoCivil: "IdEstadoCivil"};

  const [allDropdowns, setAllDropdowns] = useState([]);
  const [formValues, setFormValues] = useState({});
  
  const [isLoading, setIsLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [isEditingForm, setIsEditingForm] = useState(false);

  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [commonSelectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
  const [submitForm] = useSubmitForm();
  const [getOptions] = useGetOptionsSelect();
  const [executeGet] = useManageGetRequest();

  const allGetPromises = () => {
    return [
      getOptions(getTiposDocumentoAPI()),
      getOptions(getGenerosAPI()),
      getOptions(getEstadosCivilesAPI()),
    ]
  }

  const init = async () => {
    try {
      await manageSearch();
      initialAllOptionPromises(allGetPromises, Object.values(KEYS_INIT), successInitCallback);
    } catch (error) {
      console.error(error);
    }
  }

  const manageSearch = async () => {
    const api = getDatosIdentificacionGestionAPI(idNuevosIngresosEmpleado);
    await executeGet(api, (res) => setFormValues(res.data));
  }

  const successInitCallback = async (res) => {
    setAllDropdowns(res);
    setIsLoading(false);
  }

  const handleSubmit = async (e) => {
    if(e) e.preventDefault();
    setIsSending(true);
    try {
      const api = saveDatosIdentificacionAPI();
      await submitForm(KEYS_DATOS_IDENTIFICACION_NI, api, formValues, SECTION_NAME, successSubmitCallback, !isColaborador, () => toast.error("Faltan completar datos"));
    } catch (error) {
      console.error(error);
    } finally{
      setIsSending(false);
    }
  }

  const successSubmitCallback = () => {
    manageSearch();
    manageSearchListaDocumentos();
    if(isColaborador) setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
  }

  useDidMountEffect(() => {
    if (!isLoading && !isSending) setIsEditingForm(true);
  }, [formValues])

  useDidMountEffect(() => {
    if (isColaborador && sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent){
      handleSubmit();
    }
  }, [sendCurrentStep])

  useEffect(() => {
    init();
  }, [])

  if (isLoading) return <SpinnerLoading/>

  return (
    <form onSubmit={handleSubmit} className={`${isColaborador ? "form-colaborador-inputs" : ""}`}>
      <CardAccordion id={OPTIONS.idDatosIdentificacion} idParent={ID_PARENT} label="1. Datos de Identificación" isShow isShowGeneral={!isColaborador}>
        <div className="d-flex justify-content-center">
            <strong>
                <p>PRUEBA DE INICIAL</p>
            </strong>
        </div>
        <div className="d-flex justify-content-center card-message">
            <p>INDICACIONES:<br></br>
                1.- El presente instrumento está conformado por 21 preguntas con respuestas de alternativa múltiple, de las cuales solamente una es considerada la respuesta correcta. <br></br>
                2.- Para el desarrollo de esta prueba usted dispone de 40 minutos que deberá administrar de la manera más conveniente.<br></br>
                3.- Las respuestas incorrectas no restan puntos.<br></br>
                4.- Advertencia. Está terminantemente prohibido sustraer o copiar –total o parcialmente– este cuadernillo. Cualquier incumplimiento de las indicaciones o falta de probidad puede ser causal de anulación de la prueba y la eliminación del concurso.
            </p>
        </div>

        <div className="col-md-12">
          <DivCol required>
              <div className="form-group row form-input-modal-contactanos">
                  <label className="col-sm-12 col-form-label modal-label">1.- ¿Qué es la conciencia fonológica? <span className="required">*</span></label>
                  <div className="col-sm-12 justify-content-center align-items-center">
                      <div className="form-check">
                          <input className="form-check-input modal-ceses-input-radio-button" type="radio" name="RecomiendaReingreso" value={"true"}></input>
                          <label className="form-check-label modal-ceses-label-radio-button">
                              a. La habilidad que tiene el niño para tomar conciencia sobre las letras del ambiente.
                          </label>
                      </div>

                      <div className="form-check">
                          <input className="form-check-input modal-ceses-input-radio-button" type="radio" name="RecomiendaReingreso" value={"false"}></input>
                          <label className="form-check-label modal-ceses-label-radio-button">
                              b. La capacidad de leer textos en forma rápida y con precisión.
                          </label>
                      </div>

                      <div className="form-check">
                          <input className="form-check-input modal-ceses-input-radio-button" type="radio" name="RecomiendaReingreso" value={"false"}></input>
                          <label className="form-check-label modal-ceses-label-radio-button">
                              c. La habilidad que tiene el niño de darse cuenta que las frases y palabras están formadas por sonidos (fonemas).
                          </label>
                      </div>

                      <div className="form-check">
                          <input className="form-check-input modal-ceses-input-radio-button" type="radio" name="RecomiendaReingreso" value={"false"}></input>
                          <label className="form-check-label modal-ceses-label-radio-button">
                              d. La capacidad de producir automáticamente un mensaje fonológico.
                          </label>
                      </div>

                      <div className="form-check">
                          <input className="form-check-input modal-ceses-input-radio-button" type="radio" name="RecomiendaReingreso" value={"false"}></input>
                          <label className="form-check-label modal-ceses-label-radio-button">
                              e. La habilidad que tiene el niño de poder deletrear cada palabra porque ya sabe cómo suena cada letra.
                          </label>
                      </div>
                  </div>
              </div>
          </DivCol>
        </div>
        {(!inputDisabled && !isColaborador) && <FooterModal isDisabled={isSending || !isEditingForm}/>}
      </CardAccordion>
    </form>
  )
}

export default PruebaTecnica;

const DivCol = ({ children, required }) => {
  return (
    <div className={`col-md-12 ${required ? "div-label-required" : ""}`}>
      {children}
    </div>
  )
}